import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { PlaceHolderMode } from '@src/slide/domain/ui-model/element-modeles/property/placeholder/PlaceHolderMode';
import i18n from '@i18next/i18n';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';
import {
    IndentType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

export function canSetIndentation(model) {
    const isMultiplyModel = model.type === UIModelType.MULTIPLY;
    const isGroup = model.type === UIModelType.GROUP;
    const isNoteArea = model.type === UIModelType.NOTE;
    const isPlaceholderTitle = model.placeHolder?.type === PlaceHolderMode.TITLE;
    const isCtrTitle = model.placeHolder?.type === PlaceHolderMode.CTRTITLE;
    const isShapeNotEditing = model.type === UIModelType.SHAPE && !model.inTable && !model.editorInstance?.isEditing;
    const canEdit = getUserPriviledgeService().pptEditorState === PPTEditorStateType.EDITABLE;
    if (isMultiplyModel || isShapeNotEditing || isPlaceholderTitle || isNoteArea || !canEdit || isCtrTitle || isGroup) {
        return false;
    }
    return true;
}

export function getLimitLevelState(level, hasMaxLevel, hasMinLevel) {
    if (!(level?.length)) {
        level = [level];
    }
    level.forEach((item) => {
        if (item === 8) {
            hasMaxLevel = true;
        } else if (!item) {
            hasMinLevel = true;
        }
    });
    return [hasMaxLevel, hasMinLevel];
}

export function getShapeTableLimitLevelState(model) {
    const hasMaxLevel = false;
    const hasMinLevel = false;
    if (model.type === UIModelType.SHAPE) {
        return getLimitLevelState(model.selectionStyles?.level, hasMaxLevel, hasMinLevel);
    }
    return [hasMaxLevel, hasMinLevel];
}

export function handleIndentBtnDisableState(disableData, model) {
    let newDisableData = disableData;
    if (!canSetIndentation(model)) {
        newDisableData = newDisableData.concat({ id: ActionType.INDENT, title: i18n.t('缩进') });
        newDisableData = newDisableData.concat({ id: IndentType.INDENT_INCREASE, title: i18n.t('增加缩进') });
        newDisableData = newDisableData.concat({ id: IndentType.INDENT_REDUCE, title: i18n.t('减少缩进') });
    } else {
        const [hasMaxLevel, hasMinLevel] = getShapeTableLimitLevelState(model);
        if (hasMaxLevel) {
            newDisableData = newDisableData.concat({ id: IndentType.INDENT_INCREASE, title: i18n.t('增加缩进') });
        }
        if (hasMinLevel) {
            newDisableData = newDisableData.concat({ id: IndentType.INDENT_REDUCE, title: i18n.t('减少缩进') });
        }
    }

    return newDisableData;
}

function getUserPriviledgeService(): IUserPriviledgeService {
    return (AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices)
        .viewableServiceLayer.userPriviledgeService;
}
